export default __webpack_public_path__ + "static/media/anniversary1.c3bd3b1a.webp";